export default __webpack_public_path__ + "static/media/clock.167b9b67.svg";